const RESOURCE_NAME = '/grafana';

export default axios => ({
    grafanaSettings() {
        return axios.get(`${RESOURCE_NAME}/settings`, {});
    },
});